import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPaises,
  fetchProvincias,
  generosSelector,
  paisesSelector,
  pciasSelector,
  sexosSelector,
} from '../../appStore/commonSlice';
import { CVAPI } from '../../const';

import bsCustomFileInput from 'bs-custom-file-input';
import dateformat from 'dateformat';
import {
  fetchJurisdiccion,
  fetchTiposConcurso,
  jurisSelector,
  tiposSelector,
} from '../../components/Concursos/Gestion/gestionConcursoSlice';
import CampoDate from './CampoDate';

export const LoadingButton = ({ isLoading, children, ...props }) => {
  return (
    <Button disabled={isLoading} {...props}>
      {isLoading ? (
        <Spinner
          animation="border"
          variant="light"
          role="status"
          style={{ height: 20, width: 20, margin: '0 10px ' }}>
          <span className="sr-only">Cargando...</span>
        </Spinner>
      ) : (
        children
      )}
    </Button>
  );
};
export const ControlNumber = (props) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleChange = (ev) => {
    const reg_number = /^[0-9\b]+$/;

    const reg_0_100_integer = /^(\d|100)$/;

    const reg = props.max100 ? reg_0_100_integer : reg_number;

    if (ev.target.value === '' || reg.test(ev.target.value)) {
      setValue(ev.target.value);
      if (props.onChange) props.onChange(ev);
    } else {
      setValue(value);
    }
  };

  return <Form.Control {...props} value={value} onChange={handleChange} />;
};

export const ControlPais = ({ optional = false, ...props }) => {
  const dispatch = useDispatch();
  const paises = useSelector(paisesSelector);
  useEffect(() => {
    dispatch(fetchPaises());
  }, [dispatch]);

  return (
    <Form.Control as="select" {...props}>
      <option value="" disabled={!optional}>
        Seleccione
      </option>
      {Object.keys(paises).map((key, idx) => (
        <option key={idx} value={paises[key].idPais}>
          {paises[key].nombre}
        </option>
      ))}
    </Form.Control>
  );
};

export const ControlProvince = (props) => {
  const dispatch = useDispatch();

  const pcias = useSelector(pciasSelector);
  useEffect(() => {
    dispatch(fetchProvincias());
  }, [dispatch]);

  return (
    <Form.Control as="select" {...props}>
      <option value="">Seleccione</option>
      {pcias?.map((el, idx) => (
        <option key={idx} value={el.idProvincia ? el.idProvincia : 0}>
          {el.nombre}
        </option>
      ))}
    </Form.Control>
  );
};

var global_prov = null;
export const ControlLocalidad = (props) => {
  const [localidades, setLocalidades] = useState([]);
  var idPcia = props.pcia ? props.pcia : props.formik.values.provincia;

  if (global_prov == null) {
    global_prov = props.pcia;
  } else if (global_prov !== props.pcia) {
    (async () => {
      await Axios.get(`${CVAPI}/ciudad?provincia=${idPcia}`)
        .then((res) => {
          setLocalidades(res.data);
        })
        .catch((err) => console.error(err));
    })();
    global_prov = props.pcia;
  }
  return (
    <Form.Control as="select" {...props}>
      <option value="">Seleccione</option>
      {localidades &&
        localidades.map((el) => (
          <option key={el.idCiudad} value={el.idCiudad}>
            {el.nombre}
          </option>
        ))}
    </Form.Control>
  );
};

export const ControlOrganismo = (props) => {
  const juris = useSelector(jurisSelector);
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    const curJuris = juris.find((el) => el.idJurisdiccion === props.jurisdiccion);
    setOrgs(curJuris?.organismos);
  }, [props.jurisdiccion, juris]);

  return (
    <Form.Control as="select" {...props}>
      <option value="">Seleccione</option>
      {orgs &&
        orgs.map((el) => (
          <option key={el.idOrganismo} value={el.idOrganismo}>
            {el.nombre}
          </option>
        ))}
    </Form.Control>
  );
};

export const ControlJurisdiccion = (props) => {
  const dispatch = useDispatch();
  const juris = useSelector(jurisSelector);
  useEffect(() => {
    dispatch(fetchJurisdiccion());
  }, [dispatch]);

  return (
    <Form.Control as="select" {...props}>
      <option value="">Seleccione</option>
      {juris?.map((el, idx) => (
        <option key={idx} value={el.idJurisdiccion} title={el.descripcion}>
          {el.nombre}
        </option>
      ))}
    </Form.Control>
  );
};

export const ControlConvocatoria = (props) => {
  const dispatch = useDispatch();
  const tipos = useSelector(tiposSelector);
  useEffect(() => {
    dispatch(fetchTiposConcurso());
  }, [dispatch]);

  return (
    <Form.Control as="select" {...props}>
      <option value="">Seleccione</option>
      {tipos &&
        Object.keys(tipos).map((el, idx) => (
          <option key={idx} value={tipos[el].idTipoConcurso} title={tipos[el].descripcion}>
            {tipos[el].nombre}
          </option>
        ))}
    </Form.Control>
  );
};

export const CampoFormikFile = (props) => {
  const [nombreArchivo, setNombreArchivo] = useState('');

  useEffect(() => {
    bsCustomFileInput.init();

    if (props.value instanceof File) {
      setNombreArchivo(props.value.name);
    } else {
      if (
        props.value !== null &&
        props.value !== '' &&
        typeof props.value !== 'undefined' &&
        JSON.stringify(props.value) !== JSON.stringify({})
      ) {
        setNombreArchivo(props.value.split('/').pop());
      } else {
        setNombreArchivo('Seleccione un archivo');
      }
    }
  }, [props.value]);

  return (
    <Form.Group as={Col}>
      <Form.Label>{props.label}</Form.Label>
      <Form.File className={props.className} id="nroReso" custom>
        <Form.File.Input
          accept=".pdf,.doc,.odt,.jpg,.png"
          type="file"
          name={props.name}
          isInvalid={props.formik.touched[props.name] && !!props.errors}
          onChange={(ev) => {
            props.formik.setFieldValue(props.name, ev.currentTarget.files[0]);
            setNombreArchivo(ev.currentTarget.files[0].name);
          }}
        />
        <Form.File.Label data-browse="Cargar archivo">{nombreArchivo}</Form.File.Label>
        <Form.Control.Feedback type="invalid">{props.errors}</Form.Control.Feedback>
      </Form.File>
    </Form.Group>
  );
};

/**
 * Muestra dos opciones inline como radio button. Depende de formik por cuestiones de estilo y control
 * @param {*} props ver uso en ProfileForm
 */
export const ControlSexo = (props) => {
  const sexos = useSelector(sexosSelector);
  const checkChange = (val) => {
    props.formik.setFieldValue('sexo', val);
  };

  return (
    <>
      <Form.Control {...props} type="hidden" /> {/* name=sexo*/}
      <div className="d-flex align-items-center">
        {sexos.map((el) => (
          <Form.Check inline key={el.key}>
            <Form.Check.Input
              checked={el.key === props.value}
              type="radio"
              name="sexoCheck"
              value={el.key}
              onBlur={props.formik.handleBlur}
              isInvalid={props.formik.touched[props.sexo] && !!props.formik.sexo}
              onChange={(ev) => checkChange(ev.target.value)}
            />
            <Form.Check.Label>{el.desc}</Form.Check.Label>
          </Form.Check>
        ))}
      </div>
    </>
  );
};

export const ControlGenero = (props) => {
  const defaultGeneros = useSelector(generosSelector);

  const finalValue = defaultGeneros.find((element) => element === props.value);

  return (
    <>
      <Form.Control
        as="select"
        name={props.name}
        style={{ display: 'inline-block', width: '50%' }}
        value={finalValue || 'none'}
        onChange={({ target: { value } }) => props.formik.setFieldValue(props.name, value)}
        onBlur={props.formik.handleBlur}
        isInvalid={props.formik.touched[props.name] && !!props.formik.errors[props.name]}>
        <option value="">Seleccione</option>
        {defaultGeneros.map((el) => (
          <option key={el} value={el}>
            {el}
          </option>
        ))}
        <option value="none">Ninguna de las anteriores(especificar)</option>
      </Form.Control>
      <Form.Control
        style={{ display: 'inline-block', width: '40%', marginLeft: 5 }}
        {...props}
        value={props.value === 'none' ? '' : props.value}
        hidden={typeof defaultGeneros.find((element) => element === props.value) !== 'undefined'}
      />
    </>
  );
};

/*
  Este componente es el que se debería usar como campo para selecionar una fecha
    - Permite ingreso por teclado por cuestiones de accesibilidad
    - No oculta ningún tipo de validación, de forma que esto sea definido en el formulario formik donde debería ser visible
*/ export const ControlDate2 = (props) => {
  const handleChange = (event) => {
    const value = event.target.value;
    const isValidDate = /^(\d{4})-(\d{2})-(\d{2})$/.test(value); // Regular expression for YYYY-MM-DD format

    if (isValidDate) {
      const dateParts = value.split('-');
      const year = parseInt(dateParts[0]);
      const month = parseInt(dateParts[1]) - 1; // Months are zero-based in JavaScript Date objects
      const day = parseInt(dateParts[2]);
      const date = new Date(year, month, day);

      props.formik.setFieldValue(props.name, date);
    } else {
      props.formik.setFieldValue(props.name, null); // Clear the field if the date is invalid
    }
  };

  return (
    <Form.Control
      type="date"
      id={props.id}
      onChange={handleChange}
      isInvalid={props.formik.touched[props.name] && !!props.formik.errors[props.name]}
    />
  );
};

export const ControlDate = (props) => {
  const { disabled } = props;
  const month = props.type === 'month';
  const format = month ? 'mm/yyyy' : 'dd/mm/yyyy';
  const maxDate = props.maxDate || undefined;
  const minDate = props.minDate || undefined;

  const formikValue = props.formik.values[props.name];

  const [value, setValue] = useState('');

  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    //Permito vaciar el campo
    if (formikValue === '') {
      setValue('');
    } else {
      const selDate = new Date(formikValue);
      if (!isNaN(selDate.valueOf())) {
        setSelectedDate(selDate);
        setValue(dateformat(selDate, format));
      }
    }
  }, [formikValue, format]);

  const handleChange = (date) => {
    props.formik.setFieldValue(props.name, date ? date : '');
    setValue(date ? dateformat(date, format) : '');
  };

  return (
    <>
      <CampoDate
        id={props.id}
        maxDate={maxDate}
        minDate={minDate}
        month={month}
        selectedDate={selectedDate}
        format={format}
        name={props.name}
        disabled={disabled}
        isInvalid={props.formik.touched[props.name] && !!props.formik.errors[props.name]}
        onChange={(date) => handleChange(date)}
        onBlur={props.formik.handleBlur}
        value={value}
      />
    </>
  );
};

const ControlDateTime = (props) => {
  const { disabled, name, onChange, onBlur } = props;
  return (
    <input
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      className="form-control"
      type="datetime-local"
    />
  );
};
/**
 * Componente para abstraer las inicializaciones más comunes de campos en formularios formik.
 * prop type define el componente que se cargará. Ver ejemplos en formularios como ProfileForm
 */
export const CampoFormik = React.forwardRef((props, ref) => {
  const { handleChange, handleBlur, values, errors, touched } = props.formik;
  const { disabled } = props;
  const name = props.name;
  const labelfor = props.name;
  const id = props.name;
  const type = props.type || 'string';
  const customProps = {
    ...props,
    ref: ref,
    value: values[name],
    onChange: props.onChange || handleChange,
    onBlur: handleBlur,
    isInvalid: 'isInvalid' in props ? props.isInvalid : touched[name] && !!errors[name],
    className: props.inputClass || '',
    disabled,
  };
  delete customProps.inputClass; //Genera errores

  if (type === 'file')
    return (
      <CampoFormikFile errors={errors[name]} label={props.label} name={name} {...customProps} />
    );

  return (
    <Form.Group as={Col} style={{ position: 'relative' }} {...(props.col || '')}>
      {props.label && <Form.Label for={labelfor}>{props.label}</Form.Label>}
      <Form.Text className="help-block" style={{ fontSize: 12 }} muted>
        {props.help}
      </Form.Text>
      {/* Muestro distintos campos segun el tipo */}
      {type === 'string' && (
        <Form.Control name={name} id={id} {...customProps} value={customProps.value || ''} />
      )}
      {type === 'textarea' && <Form.Control id={id} as="textarea" name={name} {...customProps} />}
      {type === 'number' && <ControlNumber id={id} name={name} {...customProps} />}
      {type === 'pais' && <ControlPais id={id} name={name} {...customProps} />}
      {type === 'province' && <ControlProvince id={id} name={name} {...customProps} />}
      {type === 'jurisdiccion' && <ControlJurisdiccion id={id} name={name} {...customProps} />}
      {type === 'tipoConvocatoria' && <ControlConvocatoria id={id} name={name} {...customProps} />}
      {type === 'organismo' && <ControlOrganismo id={id} name={name} {...customProps} />}
      {type === 'select' && (
        <Form.Control id={id} as="select" name={name} {...customProps}>
          {props.children}
        </Form.Control>
      )}
      {type === 'localidad' && (
        <ControlLocalidad
          id={id}
          name={name}
          {...customProps}
          prov={customProps.formik.values.provincia}
        />
      )}
      {type === 'genero' && (
        <ControlGenero id={id} formik={props.formik} name={name} {...customProps} />
      )}
      {type === 'sexo' && (
        <ControlSexo id={id} formik={props.formik} name={name} {...customProps} />
      )}
      {type === 'date2' && <ControlDate2 id={id} {...customProps} />}
      {(type === 'month' || type === 'date') && (
        <ControlDate id={id} formik={props.formik} name={name} {...customProps} />
      )}

      {type === 'datetime' && <ControlDateTime id={id} name={name} {...customProps} />}

      {['password', 'time'].includes(type) && (
        <Form.Control id={id} type={type} name={name} {...customProps} />
      )}
      <Form.Control.Feedback type="invalid">{errors[name]}</Form.Control.Feedback>
    </Form.Group>
  );
});
